<template>
    <ModalComponent
        name='condiciones-plazos'
        title="Condiciones sobre el pago a plazos"
        v-on:close="() => close()"
    >
        <b-row>
            <b-col cols="12">
                <div v-if="condiciones_plazos" v-html="condiciones_plazos"></div>
                <div v-else v-html="texto_condiciones" class="text-justify"></div>
            </b-col>
        </b-row>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['condiciones_plazos', 'texto_condiciones'],
        methods: {
            close() {
                this.$emit('close', 'condiciones-plazos');
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
